import {UploadInfo} from '../object-view/upload-info';

export class UploadMediaContainer {
  uploadInfo: UploadInfo;
  files: Array<any> = [];
  fileObjects: Array<any> = [];
  parentObject: any;
}

